// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as CatalogProductEditForm from "./CatalogProductEditForm.res.js";
import * as CatalogProductEditFormInputs from "./CatalogProductEditFormInputs.res.js";

function CatalogProductEditFormInformationFieldsetPanel(props) {
  let state = CatalogProductEditForm.useFormState();
  let productKind = state.initialValues.kind;
  let match = state.values.color;
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("General information"),
    description: I18n.t("Complete the product information.\nThe information of this reference will be later enriched by the information of the variant."),
    children: [
      JsxRuntime.jsx(CatalogProductEditForm.InputText.make, {
        field: "Name",
        label: I18n.t("Product's name"),
        placeholder: I18n.t("Product's name")
      }),
      productKind === "WINE" || productKind === "BEER" || productKind === "SPIRITUOUS" ? JsxRuntime.jsxs(Group.make, {
          children: [
            productKind === "SPIRITUOUS" ? JsxRuntime.jsx(CatalogProductEditFormInputs.ProductFamilyComboBox.make, {}) : (
                productKind === "WINE" || productKind === "BEER" ? JsxRuntime.jsx(CatalogProductEditFormInputs.ColorSelect.make, {}) : null
              ),
            productKind === "BEER" ? JsxRuntime.jsx(CatalogProductEditFormInputs.ProductBeerTypeComboBox.make, {}) : (
                productKind === "WINE" ? JsxRuntime.jsx(CatalogProductEditFormInputs.WineTypeSelect.make, {}) : null
              )
          ]
        }) : null,
      productKind === "WINE" && match === "WHITE" ? JsxRuntime.jsx(CatalogProductEditFormInputs.WhiteWineTypeSelect.make, {}) : null,
      productKind === "WINE" ? JsxRuntime.jsxs(Group.make, {
          children: [
            JsxRuntime.jsx(CatalogProductEditFormInputs.ProductProducerComboBox.make, {}),
            JsxRuntime.jsx(CatalogProductEditFormInputs.ProductDesignationComboBox.make, {})
          ]
        }) : null,
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(CatalogProductEditFormInputs.ProductCountrySelect.make, {}),
          productKind === "WINE" ? JsxRuntime.jsx(CatalogProductEditFormInputs.ProductRegionComboBox.make, {}) : JsxRuntime.jsx(CatalogProductEditFormInputs.ProductProducerComboBox.make, {})
        ]
      }),
      JsxRuntime.jsx(CatalogProductEditFormInputs.ProductTaxSelect.make, {
        productKind: productKind
      })
    ]
  });
}

let make = React.memo(CatalogProductEditFormInformationFieldsetPanel);

export {
  make,
}
/* make Not a pure module */
